import mapRoomsToSortRequest from './mappers/mapRoomsToSortRequest'

export default function(api: GlobalFetch) {
  return async function(rooms) {
    const requestBody = mapRoomsToSortRequest(rooms)

    const response = await api.fetch(`/api/v2/room/sort`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    if (response.ok) {
      return await response.json()
    } else {
      throw new Error(response.status.toString())
    }
  }
}
